import React, { useState, useEffect } from "react";
import ProductTitile from './ProductTitile';
import useStateRef from "react-usestateref";
import './PlpContainer.css';
import { Link } from "react-router-dom";

const PlpMainContent = ({ containerObject }) => {

	const [containerObjectState, setContainerObjectState] = useState(containerObject && containerObject.results ? containerObject.results : "")
	const [searchedvalue, setSearchedvalue, searchedvalueRef] = useStateRef(containerObject.searchedValue ? containerObject.searchedValue : "")
	const [search, setSearch, searchRef] = useStateRef("");
	const [facetFields, setFacetFields, facetFieldsRef] = useStateRef(false);

	useEffect(() => {
		//search = window.location.search
		setSearch(window.location.search)
	}, [])

	useEffect(() => {
		let params = new URLSearchParams(searchRef.current)
		params = params.toString()
		console.log('params ---- ', params)
		if (containerObject && containerObject.results && containerObject.results.length == 1 && containerObject.isSearchPage === true && !params.includes("facetFields")) {
			setFacetFields(true)
			containerObject.results.map(oneElem => {
				window.location.replace(oneElem.productUrl)
			})
		}
	}, [containerObject])
	
	
	
	useEffect(()=>{
		const titleElement = document.querySelector('title')
		if(containerObject.currentCategoryName) { 
			titleElement.innerHTML = containerObject.currentCategoryName + " | Carolina Open Science  Education"
		} else if(containerObject.isSearchPage === true && containerObject.isSearchPage) {
			titleElement.innerHTML = "Carolina Open Science  Education Search for: " + containerObject.searchedValue
		} else {
			titleElement.innerHTML = "Carolina Open Science  Education"
		}
	},[containerObject])
	
	
	return (<>

		
			{containerObjectState && containerObjectState.length == 1 && containerObject.isSearchPage === true && facetFieldsRef.current === true ? "" :
			<>
				{containerObjectState && containerObjectState.length > 0  && !containerObject.hidePlpPage ? 
					<div className="col-md-12 container-fluid justify-content-around row os-products-right">
						{/* Facet Mobile view button */}
						<div className={`row d-lg-none d-block mb-5 mt-5 p-0 ${containerObject && containerObject.isChildCategoryAvailable ? "d-none" : ""}`}>
							<div className="ose-refine-btn">
								<button class="btn btn-os-primary" type="button" data-bs-toggle="offcanvas" data-bs-target="#oseOffcanvasRight" aria-controls="offcanvasRight">Refine Results</button>
							</div>
						</div>

						{searchedvalueRef.current ?
							<div className="c-results-tabs">
								<ul id='myTabProduct' className='nav nav-tabs' role='tablist'>
									{containerObject && containerObject.Product ? <li className={`nav-item`} role='presentation'>
										<Link class={`nav-link text-center ${containerObject.productViewType === "p" ? "active" : ""}`} type="button" aria-selected="true">Products <span class="c-tab-count">({containerObject.Product ? containerObject.Product : ""})</span></Link>
									</li> : ""}
								</ul>
							</div> : ""}
						

						<div class={`row p-0 ${containerObject && containerObject && containerObject.isSearchPage && containerObject.isSearchPage === true && facetFieldsRef.current === true ? "" : ""}`}>
						{containerObject && containerObject.results && containerObject.results.length == 1 && containerObject.isSearchPage === true && facetFieldsRef.current === true ? "" :
							<>
								{containerObject.results ? containerObject.results.map((value, index) => {
									return (<>
										<ProductTitile value={value} domainName={containerObject.domainName ? containerObject.domainName : ""} />
									</>)
								}) : ""}
							</> }
						</div>

					</div> : ""}</>}
		</>
	)
}

export default PlpMainContent